export default __webpack_public_path__ + "static/media/bridge.8b476695.svg";